import { render } from "./NotificationSetting.vue?vue&type=template&id=40bb114a"
import script from "./NotificationSetting.vue?vue&type=script&lang=js"
export * from "./NotificationSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__